import { render, staticRenderFns } from "./create-edit.vue?vue&type=template&id=70383317&scoped=true&"
import script from "./create-edit.vue?vue&type=script&lang=js&"
export * from "./create-edit.vue?vue&type=script&lang=js&"
import style0 from "./create-edit.vue?vue&type=style&index=0&id=70383317&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70383317",
  null
  
)

export default component.exports